angular.module('unergie.main')
.directive('jsonformatterdetails', ($sce, mapUtils) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/jsonformatterdetails/jsonformatterdetails.html',
        scope: {
            details: '=',
            placement: '=',
            hover: '=',
        },
        link($scope) {
            $scope.prevent = function (e) {
                e.preventDefault()
                e.stopPropagation()
            }
        },
    })
)
